import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue"

import SogCardActionButton from '@/shared/ui/SogCardActionButton.vue';
import SogCardActions from '@/shared/ui/SogCardActions.vue';
import SogCardContent from '@/shared/ui/SogCardContent.vue';
import SogCardTitle from '@/shared/ui/SogCardTitle.vue';
import SogDatePicker from '@/shared/ui/SogDatePicker.vue';
import SogRadioButtonGroup from '@/shared/ui/SogRadioButtonGroup.vue';
import SogDataLabel from '@/shared/ui/SogDataLabel.vue';

import { ref, onMounted } from 'vue';
import { SogDataLabelValueType } from '@/shared/ui/types/SogDataLabelValueType';
import PersonDetails from '@/shared/model/personDetails';
import PersonDetailsId from '@/shared/model/personDetailsId';
import Person from "@/shared/model/person";
import SogCard from '@/shared/ui/SogCard.vue';

import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import {useAccountStore} from "@/stores/accountStore";

enum statuses {
  endabnehmer = 'EndCustomer',
  vertriebspartner = 'Agent'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonStatusCardComponent',
  props: {
    details: {},
    person: {}
  },
  emits: ['onSaveClick', 'onFinishEdit'],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const _accountStore = useAccountStore()

const _personStatus = ref(props.details.getValue(PersonDetailsId.CustomerType))

const _agentFrom = props.details.getValue(PersonDetailsId.AgentFrom)
const _agentTill = props.details.getValue(PersonDetailsId.AgentTill)

const _beginDate = ref<Date | undefined>(_agentFrom != undefined ? new Date(props.details.getValue(PersonDetailsId.AgentFrom)) : undefined)
const _endDate = ref<Date | undefined>(_agentTill != undefined ? new Date(props.details.getValue(PersonDetailsId.AgentTill)) : undefined)

const _editedPersonStatus = ref(_personStatus.value)
const _editedBeginDate = ref<Date | undefined>(_beginDate.value)
const _editedEndDate = ref<Date | undefined>(_endDate.value)
const _editing = ref(false)


onMounted(() => {
  onStatusReset()
})

const reloading = ref(false)

function reload() {
  reloading.value = true
  setTimeout(() => {
    reloading.value = false
  }, 100)
}

async function onStatusUpdate() {
  emit('onSaveClick')
  try {
    const requestBody = getDetails().getValues()
    const res = await apiOrganisationStructure.updateDetails(_accountStore.person?.id, props.person?.id, requestBody)
  
    if(res) {
      emit('onFinishEdit', true)
      _editing.value = false
      _personStatus.value = _editedPersonStatus.value
      _beginDate.value = _editedBeginDate.value
      _endDate.value = _editedEndDate.value
    } else {
      emit('onFinishEdit', false)
    }
  } catch {
    emit('onFinishEdit', false)
  }
}

function startEditing() {
  _editing.value = true
}

function cancel() {
  _editing.value = false
  onStatusReset()
}

function onStatusReset() {
  _editedPersonStatus.value = _personStatus.value
  _editedBeginDate.value = _beginDate.value
  _editedEndDate.value = _endDate.value
  reload()
}

function getDetails() {
  const details = new PersonDetails(props.details?.getValues())
  details.setValue(PersonDetailsId.CustomerType, _editedPersonStatus.value)

  if(_editedPersonStatus.value === statuses.vertriebspartner) {
    details.setDateValue(PersonDetailsId.AgentFrom, _editedBeginDate.value as Date)
    details.setDateValue(PersonDetailsId.AgentTill, _editedEndDate.value as Date)
  }
  return details
}



return (_ctx: any,_cache: any) => {
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("Kundenstatus", -1)
        ]))]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_personStatus.value === statuses.vertriebspartner ? 'Vertriebspartner' : 'Endabnehmer'), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, !_editing.value]
      ]),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          (!reloading.value)
            ? (_openBlock(), _createBlock(SogRadioButtonGroup, {
                key: 0,
                modelValue: _editedPersonStatus.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_editedPersonStatus).value = $event)),
                name: _personStatus.value,
                items: [
          {label: 'Endabnehmer', value: statuses.endabnehmer},
          {label: 'Vertriebspartner', value: statuses.vertriebspartner},
        ]
              }, null, 8, ["modelValue", "name", "items"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512), [
        [_vShow, _editing.value]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Vertriebsvereinbarung", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogDatePicker, {
              modelValue: _editedBeginDate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_editedBeginDate).value = $event)),
              max: _editedEndDate.value,
              placeholder: "Beginn"
            }, null, 8, ["modelValue", "max"]),
            _createVNode(SogDatePicker, {
              modelValue: _editedEndDate.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_editedEndDate).value = $event)),
              min: _editedBeginDate.value,
              placeholder: "Ende"
            }, null, 8, ["modelValue", "min"])
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _editedPersonStatus.value === statuses.vertriebspartner && _editing.value]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("Vertriebsvereinbarung", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, "Beginn", -1)),
                _createElementVNode("td", null, [
                  (_beginDate.value)
                    ? (_openBlock(), _createBlock(SogDataLabel, {
                        key: 0,
                        value: _beginDate.value,
                        "value-type": _unref(SogDataLabelValueType).Date
                      }, null, 8, ["value", "value-type"]))
                    : (_openBlock(), _createBlock(_component_center, {
                        key: 1,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" - ", -1)
                        ]))]),
                        _: 1
                      }))
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[12] || (_cache[12] = _createElementVNode("td", null, "Ende", -1)),
                _createElementVNode("td", null, [
                  (_endDate.value)
                    ? (_openBlock(), _createBlock(SogDataLabel, {
                        key: 0,
                        value: _endDate.value,
                        "value-type": _unref(SogDataLabelValueType).Date
                      }, null, 8, ["value", "value-type"]))
                    : (_openBlock(), _createBlock(_component_center, {
                        key: 1,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" - ", -1)
                        ]))]),
                        _: 1
                      }))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _personStatus.value === statuses.vertriebspartner && !_editing.value]
      ]),
      _withDirectives(_createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-pencil",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (startEditing()))
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, !_editing.value]
      ]),
      _withDirectives(_createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-content-save",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (onStatusUpdate()))
          }),
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-cancel",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (cancel()))
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _editing.value]
      ])
    ]),
    _: 1
  }))
}
}

})